import script from "./SubscriptionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubscriptionList.vue?vue&type=script&setup=true&lang=ts"

import "./SubscriptionList.vue?vue&type=style&index=0&id=9deee534&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9deee534"]])

export default __exports__